<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('ui.updatePermissionGroup'): $t('ui.createPermissionGroup')"
                        :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75"
                :loading="loading">

          <v-card class="m-4" outlined
                  :loading="employeeLoading"
          >
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>

            <div class="px-6 pt-6">

              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-h5">{{ $t('ui.permissionGroupName') }}</p>
              </div>
              <v-textarea
                  v-model="pmsGroup.functionalGroupName"
                  :placeholder="$t('ui.permissionGroupPermissionNameInput')"
                  :rules="ruleFunctionalGroupName"
                  auto-grow
                  rows="1"
                  counter="255"
                  outlined
              >
              </v-textarea>


              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-h5">{{ $t('ui.description') }}</p>
              </div>
              <v-textarea
                  v-model="pmsGroup.description"
                  :placeholder="$t('ui.descriptionGroupPermissionInput')"
                  :rules="ruleDescription"
                  auto-grow
                  counter="255"
                  rows="3"
                  outlined
              >
              </v-textarea>
              <div class="d-flex">
                <div class="ms-1 text-h5">{{ $t('ui.medicalStaffList') }}</div>
              </div>

              <div>
                <v-chip
                    class="ma-1"
                    v-for="employee in confirmedEmployees"
                    :key="employee.name"
                    close
                    close-icon="mdi-close"
                    label
                    outlined>
                  {{ employee.name }}
                </v-chip>

              </div>

              <v-btn
                  elevation="0"
                  class="mt-4 mb-6 no-uppercase btn-custom-primary"
                  @click="openSelectEmployee">
                {{ $t('ui.addMedicalStaff') }}
              </v-btn>

              <div v-if="item"
                   class="d-flex align-center">
                <v-switch
                    inset
                    v-model="activeGroup"
                ></v-switch>
                <div class="text-body-1">{{ $t('ui.activeGroup') }}</div>
              </div>


            </div>

          </v-card>
          <v-card class="m-4" outlined
                  :loading="funLoading"
          >
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("ui.setPermissions") }}</div>
            </div>

            <div class="d-grid">

              <v-card class="card-border-10 ma-2 pa-2"
                      v-for="func in listFunctions"
                      :key="func.functionId"
                      outlined>

                <v-checkbox
                    class="pms-checkbox"
                    v-model="selectedFunctions"
                    :disabled="func.deleted === 1"
                    :value="func.functionId">

                  <template v-slot:label>
                    <div class="text-body-1 mt-2">{{ locale === 'vi' ? func.functionName : func.functionNameEng }}</div>
                  </template>
                </v-checkbox>

                <v-checkbox
                    class="ms-6 pms-checkbox"
                    v-model="selectedFunctions"
                    :disabled="func.deleted === 1"
                    :value="func.functionId">

                  <template v-slot:label>
                    <div class="text-body-2 mt-2">{{ $t('ui.view') }}</div>
                  </template>
                </v-checkbox>

                <v-checkbox
                    class="ms-6 pms-checkbox"
                    v-model="selectedFunctions"
                    :disabled="func.deleted === 1"
                    :value="func.functionId">

                  <template v-slot:label>
                    <div class="text-body-2 mt-2">{{ $t('base.create') }}</div>
                  </template>
                </v-checkbox>

                <v-checkbox
                    class="ms-6 pms-checkbox"
                    v-model="selectedFunctions"
                    :disabled="func.deleted === 1"
                    :value="func.functionId">
                  <template v-slot:label>
                    <div class="text-body-2 mt-2">{{ $t('base.edit') }}</div>
                  </template>
                </v-checkbox>

                <v-checkbox
                    class="ms-6 pms-checkbox"
                    v-model="selectedFunctions"
                    :disabled="func.deleted === 1"
                    :value="func.functionId">
                  <template v-slot:label>
                    <div class="text-body-2 mt-2">{{ $t('base.delete') }}</div>
                  </template>
                </v-checkbox>

              </v-card>

            </div>

          </v-card>
          <div class=" m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                :disabled="!isFormValid"
                @click="onSave">
              {{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </div>
      <v-dialog
          content-class="card-border-20"
          v-model="employeesDialog"
          max-width="90%"
          persistent>

        <v-card
            class="card-border-20 pb-6">
          <v-card-title>
            <div class="w-100 d-flex">
              <div class="text-h6">{{ $t("ui.addMedicalStaff") }}</div>

              <v-btn class="ms-auto"
                     icon
                     @click="employeesDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

            </div>

          </v-card-title>
          <div class="px-6">

            <v-data-table
                hide-default-footer
                class="home-data-table mt-10 text-body-1"
                show-select
                :page.sync="currentPage"
                :items-per-page="perPage"
                :single-select="false"
                v-model="selectedEmployees"
                :loading="loading"
                :headers="headers"
                item-key="name"
                :items="listEmployees">

              <template v-slot:item.name="{ item }">
                <div class="ellipsis-cell" style="max-width: 220px;" :title="item.name">
                  <span class="font-weight-bold">{{ item.name }}</span>
                </div>
              </template>

              <template v-slot:item.email="{ item }">
                <div class="ellipsis-cell" style="max-width: 220px;" :title="item.email">
                  {{ item.email }}
                </div>
              </template>

              <template v-slot:item.department="{ item }">
                <div class="ellipsis-cell" style="max-width: 220px;" :title="item.department">
                  {{ item.department }}
                </div>
              </template>

              <template v-slot:item.title="{ item }">
                <div class="ellipsis-cell" style="max-width: 220px;" :title="item.title">
                  {{ item.title }}
                </div>
              </template>

              <template slot="no-data">
                <div class="w-100 align-content-center" style="min-height: 500px">
                  <div class="w-100 d-flex">
                    <img class="mx-auto" src="@/assets/images/ic-empty.svg" alt="empty"/>
                  </div>
                  <div class="text-center">{{ $t("base.noData") }}</div>
                </div>
              </template>

            </v-data-table>

            <div class="d-flex mt-6">
              <div class="ms-auto mt-3"> {{ paginationCurrentText }}</div>
              <b-pagination
                  class="custom-pagination"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table">
              </b-pagination>
            </div>

            <div class="d-flex">
              <v-btn
                  elevation="0"
                  class="ms-auto no-uppercase btn-custom-primary"
                  @click="confirmSelectEmployee">
                {{ $t('ui.confirm') }}
              </v-btn>
            </div>

          </div>

        </v-card>
      </v-dialog>
    </div>
  </v-form>
</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";
import i18n from "../../lang/i18n";
import {mapState} from "vuex";

export default {
  name: "CreateOrUpdate",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      employeeLoading: false,
      funLoading: false,
      pmsGroup: this.getDefaultPmsGroup(),
      employeesDialog: false,
      listEmployees: [],
      selectedEmployees: [],
      confirmedEmployees: [],
      listFunctions: [],
      selectedFunctions: [],
      activeGroup: false,
      currentPage: 1,
      perPage: 10,
      isFormValid: false
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    ...mapState(['locale']),
    headers() {
      return [
        {value: "name", text: i18n.t("ui.name")},
        {value: "email", text: i18n.t("ui.email")},
        {value: "phoneNumber", text: i18n.t("ui.phoneNumber")},
        {value: "department", text: i18n.t("employee.department")},
      ];
    },
    totalRows() {
      return this.listEmployees.length
    },
    paginationCurrentText() {
      let last = this.currentPage * this.perPage
      let first = last - this.perPage + 1
      let total = this.totalRows
      last = last > total ? total : last
      return `${first} - ${last} / ${total}`
    },
    ruleFunctionalGroupName() {
      return [
        this.pmsGroup.functionalGroupName.length > 0
        && this.pmsGroup.functionalGroupName.length <= 255 || this.$t("ui.MSG0036"),
        this.pmsGroup.functionalGroupName.trim().length > 0 || this.$t("ui.MSG0036")
      ]
    },
    ruleDescription() {
      return [
        this.pmsGroup.description.length > 0
        && this.pmsGroup.description.length <= 255 || this.$t("ui.MSG0036"),
        this.pmsGroup.description.trim().length > 0 || this.$t("ui.MSG0036")
      ]
    },
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.$refs.form.resetValidation()
      this.initData()
      if (item) this.getData(item)
    },
    initData() {
      // this.selectedEmployees = []
      this.listFunctions = []
      this.confirmedEmployees = []
      this.selectedFunctions = []
      this.activeGroup = true
      this.getListEmployee()
      this.getListFunction()
      this.pmsGroup = this.getDefaultPmsGroup()
    },
    getDefaultPmsGroup() {
      return {
        functionalGroupName: "",
        description: "",
        deleted: 0,
      }
    },
    async getData(item) {
      let res = await this.get(API2.GET_FUNCTIONAL_GROUP, {functionalGroupId: item.functionalGroupId})
      if (!res) {
        // No data found, go back to list
        this.onGoBack();
        return;
      }

      this.pmsGroup = res
      this.activeGroup = res.deleted === 0
      await this.getListEmployee()
      let selectedEmails = this.pmsGroup.listEmails.split(",")
      this.confirmedEmployees = this.listEmployees.filter(e => selectedEmails.includes(e.email))

      await this.getListFunction()
      this.selectedFunctions = this.pmsGroup.listFunctions.split(",").map(e => parseInt(e))
    },
    async getListEmployee() {
      let res = await this.get(API2.EMPLOYEE, null, "employeeLoading")
      if (!res) return
      this.listEmployees = res.data
      for (let employee of this.listEmployees) employee.department = employee.departmentInfo.name
    },
    async getListFunction() {
      let res = await this.get(API2.GET_GRANT_FUNCTIONS, null, "funLoading")
      if (!res) return

      // Filter out specific permission groups that should not be displayed
      const excludedFunctions = ['Tài khoản', 'Cài đặt'];

      this.listFunctions = res.rows.filter(e => {
        // Check if the function name (Vietnamese or English) should be excluded
        return !excludedFunctions.includes(e.functionName) && !excludedFunctions.includes(e.functionNameEng);
      }).map(e => {
        //todo config test
        let hgf = e["HospitalGrantFunctions"]
        if (Array.isArray(hgf) && hgf.length > 0)
          e.deleted = hgf[0].deleted
        return e
      })
    },
    async openSelectEmployee() {
      this.selectedEmployees = [...this.confirmedEmployees]
      this.employeesDialog = true
    },
    async confirmSelectEmployee() {
      this.confirmedEmployees = [...this.selectedEmployees]
      this.employeesDialog = false
    },
    async onSave() {
      let request = {...this.pmsGroup}
      request.listEmails = this.confirmedEmployees.map(e => e.email).join(",")
      request.listFunctions = this.selectedFunctions.join(",")
      request.deleted = this.activeGroup ? 0 : 1

      if (!this.item) {
        let res = await this.post(API2.CREATE_FUNCTIONAL_GROUP, request)
        if (!res) return
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.createSuccessful"))
        this.openTab(0)
      } else {
        request.functionalGroupId = this.item.functionalGroupId
        let res = await this.put(API2.UPDATE_FUNCTIONAL_GROUP, request)
        if (!res) return
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.updateSuccessful"))
        this.openTab(0)
      }
    },
  },
}
</script>

<style scoped>

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

.custom-pagination >>> .page-item {
  margin: 5px;
}

.custom-pagination >>> .page-item .page-link {
  color: #000000;
}

.custom-pagination >>> .active > .page-link {
  background: unset;
  color: #1890FF;
  border: 1px solid #1890FF;
}

.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.custom-pagination >>> .disabled > .page-link {
  color: #D9D9D9;
}

.d-grid {
  display: grid;
  grid-template-columns: auto auto auto;
}

.pms-checkbox {
  margin: 0;
}

.pms-checkbox >>> .v-messages {
  display: none;
}

.pms-checkbox >>> .v-input__slot {
  margin: 0;
}

</style>